const EventsCom = (props) => {
  return (
    <div
      className={`xs:px-1 xs:py-1.5 sm:px-1.5 sm:py-2.5 lg:px-2 lg:py-4 flex justify-between flex-col cursor-pointer xs:h-48 sm:h-52 lg:h-[368px] items-center xs:rounded-lg sm:rounded-xl lg:rounded-[20px] ${props.eventLayout}`}
      style={{ backgroundColor: props.eventtheme }}
      onClick={props.onClick}
    >
      <img
        src={props.eventthubmail}
        className={`w-full object-cover xs:rounded-lg sm:rounded-xl lg:rounded-[20px] ${props.eventsimgClassName}`}
        alt="eventthubmail"
      />
      <div
        className={`flex justify-center items-center flex-col xs:pt-2 sm:pt-2 lg:pt-5 ${props.eventsTextClassName}`}
      >
        <div className={`${props.maxWClassname} lg:mb-1`}>
          <p
            className={`uppercase text-primary font-onestExtraBold line-clamp-2 text-center xs:text-xs sm:text-xs lg:text-lg 2xl:text-[20px] xs:leading-3 sm:leading-4 lg:leading-5  ${props.textclassName}`}
          >
            {props.eventTitle}
          </p>
        </div>
        <div className="flex items-start xs:gap-x-1 lg:gap-x-2">
          <p className="text-primary font-onestSemiBold xs:text-[12px] sm:text-xs lg:text-lg">
            {props.evetDate}
          </p>
          <p className="text-primary font-onestSemiBold text-center xs:text-[8px] sm:text-[8px] lg:text-sm leading-3 xl:text-base">
            {props.eventDis}
          </p>
        </div>
      </div>
    </div>
  );
};
export default EventsCom;
